export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-down-white.cf75f5bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};